export default __webpack_public_path__ + "media/images/tenant/chooseTabas/reason_2-df0e50293320e42a29fdd7d893a87d43.jpg";